<template>
  <div
    class="pg-soundcloud-block"
    @click="toggle()"
  >
    <div :class="{'player': true, 'playing': isPlaying}">
      <span :class="{'indicator': true, 'playing': isPlaying}">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="M0 0h24v24H0z"
            fill="none"
          />
          <path
            d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
            fill="#1ebad7"
            stroke="#1ebad7"
          />
        </svg>
      </span>
      <span :class="{'indicator-pause': true, 'playing': isPlaying}">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="M0 0h24v24H0z"
            fill="none"
          />
          <path
            d="M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
            fill="#1ebad7"
            stroke="#1ebad7"
          />
        </svg>
      </span>
      <audio
        ref="audio"
        :class="{'playing': isPlaying}"
        :src="`${require(`@/assets/bias-fx2/sound-page/${url}`)}`"
        preload="auto"
      />
      <span class="info">{{ name }}</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  components: {},
  props: {
    url: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isPlaying: false
    }
  },
  computed: {
    ...mapState('Soundclip', {
      globalIsPlaying: 'pageCurrentPlaying'
    })
  },
  watch: {
    globalIsPlaying: function (newVal, oldVal) {
      if (newVal && newVal !== this.url) {
        this.$refs['audio'].pause()
        this.isPlaying = false
      }
    }
  },
  methods: {
    ...mapMutations('Soundclip', {
      globalPlay: 'PLAY',
      globalPause: 'PAUSE'
    }),
    toggle () {
      return this.isPlaying ? this.pause() : this.play()
    },
    play () {
      // this.$refs['audio'].volume = 0.03
      this.$refs['audio'].play()
      this.isPlaying = true
      this.globalPlay(this.url)
    },
    pause () {
      this.$refs['audio'].pause()
      this.isPlaying = false
      this.globalPause()
    }
  }
}
</script>

<style scoped lang="scss">
.pg-soundcloud-block {
}

.player {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info {
  color: #52d4ea;
  margin-left: 0.5rem;
}

.indicator {
  padding-top: 7px;
}

.indicator-pause {
  padding-top: 7px;
  display: none;
}

.indicator-pause.playing {
  display: initial;
}

.indicator.playing {
  display: none;
}
.pg-soundcloud-block-disable > div {
  cursor: default;
  span.info {
    color: #b5b5b5;
  }
  path:last-of-type {
    stroke: #b5b5b5;
    fill: #b5b5b5;
  }
}
span {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/soundclip.vue